export default __webpack_public_path__ + "static/media/movies_by_monet_intro.ec895cef.mp3";